import React, { useCallback } from 'react';
import RoundImage from '../RoundImage';
import stylesheet from './ListItem.module.scss';
import ContainedImage from '../ContainedImage';

export function ListItemImage(props) {
    const { className = '', href, round, onClick, ...otherProps } = props;

    const handleClick = useCallback(() => {
        if (href) app.history.push(href);
        if (onClick) onClick();
    }, [href, onClick]);

    return (
        <ContainedImage
            className={[stylesheet.image, className, href || onClick ? 'clickable' : '', round ? stylesheet.round : ''].join(' ')}
            onClick={href || onClick ? handleClick : null}
            {...otherProps}
        />
    );
}
